
import { initializeApp, getApps } from 'firebase/app';
import { initializeAnalytics, setUserId, setUserProperties, logEvent } from 'firebase/analytics';

const cfg = window.__FIREBASE_ANALYTICS_CONFIG__;

// GA4-only custom-event helper. Default no-op so callers are always safe to call,
// even in local / when analytics is disabled. Real implementation is wired up
// below once Analytics is initialized.
//   window.trackGAEvent('cta_click', { location: 'hero' });
// Note: GA4 prefers snake_case event names (<=40 chars) and snake_case params.
window.trackGAEvent = window.trackGAEvent || function () {};

// Disabled in local, and a missing Measurement ID means there's nothing to send to.
if (cfg.enabled && cfg.firebase.measurementId) {
  const app = getApps().length ? getApps()[0] : initializeApp(cfg.firebase);

  // Scope the _ga (client_id) cookie to the same cross-subdomain domain as the
  // app's GA4 init (see react-app/src/FirebaseApp.ts) so both share one client_id.
  const analytics = initializeAnalytics(app, {
    config: {
      cookie_domain: cfg.cookieDomain,
      cookie_flags: cfg.secureCookie ? 'secure;samesite=lax' : 'samesite=lax',
    },
  });

  // Expose for manual events elsewhere, mirroring window.mixpanel / window.trackEvent.
  window.firebaseAnalytics = analytics;

  // GA4-only custom-event helper (mirrors window.trackEvent for Mixpanel).
  window.trackGAEvent = function (eventName, properties) {
    try {
      logEvent(analytics, eventName, properties || {});
    } catch (e) {
      /* never let analytics break the page */
    }
  };

  // --- Preserve user + gclid via the shared _<env>_ocamaker cookie ---
  // getOcamakerData() is defined by ocamaker-cookie.liquid (included earlier in
  // the page via navigation), so the cookie/gclid are already captured by now.
  const data = (typeof window.getOcamakerData === 'function' && window.getOcamakerData()) || {};
  const urlParams = new URLSearchParams(window.location.search);

  // user_id: prefer a uid passed in the URL (e.g. when the app links back),
  // otherwise reuse the one persisted in the shared cookie.
  const uid = urlParams.get('uid') || data.uid;
  if (uid) {
    setUserId(analytics, uid);
  }

  // gclid + attribution as user properties so GA4 retains them on this site too.
  const userProps = {};
  if (data.gclid) userProps.gclid = data.gclid;
  if (data.fbclid) userProps.fbclid = data.fbclid;
  if (data.utm_source) userProps.utm_source = data.utm_source;
  if (data.utm_medium) userProps.utm_medium = data.utm_medium;
  if (data.utm_campaign) userProps.utm_campaign = data.utm_campaign;
  if (data.utm_term) userProps.utm_term = data.utm_term;
  if (data.utm_content) userProps.utm_content = data.utm_content;
  if (data.language) userProps.language = data.language;
  if (Object.keys(userProps).length > 0) {
    setUserProperties(analytics, userProps);
  }
}
